module.exports = __webpack_public_path__ + "img/logo.30583130.png";